import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ActionCableVue from 'actioncable-vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';
import VueTailwind from 'vue-tailwind';
import './index.css';

Vue.config.productionTip = false;

Vue.use(ActionCableVue, {
	debug: true,
	debugLevel: 'error',
	connectionUrl: 'ws://localhost:3000/cable', // or function which returns a string with your JWT appended to your server URL as a query parameter
	connectImmediately: true,
});

Vue.use(Vuex);
Vue.use(VueCookies);

const settings = {};

Vue.use(VueTailwind, settings);

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');
